import {
  InteractionStepType,
  ChatApiEndpointWithId,
  DEFAULT_SEARCH_AUTOCOMPLETE_TITLE,
  DEFAULT_SEARCH_AUTOCOMPLETE_SUBTITLE,
  ProjectChatApiEndpointWithId,
} from '@scale/shared/types/chat';
import StringInputBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/StringInputBuilder';
import ChatApiEndpointsBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ChatApiEndpointsBuilder';
import {
  ConditionalStepConfig,
  ReviewLevelConfig,
} from 'react-scale/components/scalers/tasks/ThreadedInteraction/definitions/configs';
import { StepConfigurationComponentProps } from '../../stepDescriptor/types';
import { memo } from 'react';

const SearchReferencesConfigurationComponent = ({
  params: currentParams,
  setParams: setCurrentParams,
  previousParams,
  taskParams,
}: StepConfigurationComponentProps<InteractionStepType.SearchReferences>) => {
  return (
    <div className="flex flex-col gap-4">
      <StringInputBuilder
        name={'Title'}
        placeholder={DEFAULT_SEARCH_AUTOCOMPLETE_TITLE}
        existingValue={currentParams.title}
        updateProperty={(value: string) => setCurrentParams({ ...currentParams, title: value })}
        required={true}
      />

      <StringInputBuilder
        name={'Subtitle'}
        placeholder={DEFAULT_SEARCH_AUTOCOMPLETE_SUBTITLE}
        existingValue={currentParams.subtitle}
        updateProperty={(value: string) => setCurrentParams({ ...currentParams, subtitle: value })}
      />

      <div className="flex flex-col gap-2">
        <ChatApiEndpointsBuilder
          existingValue={currentParams.params.chat_models}
          updateProperty={(value: Array<ChatApiEndpointWithId | ProjectChatApiEndpointWithId>) =>
            setCurrentParams({
              ...currentParams,
              params: { ...currentParams.params, chat_models: value },
            })
          }
          maxNumberOfEndpoints={1}
        />
      </div>

      <ReviewLevelConfig currentParams={currentParams} setCurrentParams={setCurrentParams} />
      <ConditionalStepConfig
        currentParams={currentParams}
        setCurrentParams={setCurrentParams}
        previousParams={previousParams}
        taskParams={taskParams}
      />
    </div>
  );
};

export default memo(SearchReferencesConfigurationComponent);
